import React from 'react';

import * as S from './styles';

const Content: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <S.Content>{children}</S.Content>
);

export default Content;
